import { render, staticRenderFns } from "./EditPlanRemark.vue?vue&type=template&id=68e13cab&scoped=true"
import script from "./EditPlanRemark.vue?vue&type=script&lang=js"
export * from "./EditPlanRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e13cab",
  null
  
)

export default component.exports